import { getThemeForKey, Styles } from "@mcleod/core";

export const RadioButtonStyles = Styles.make("rdb", () => {
    return {
        image: {
            display: "flex",
            alignItems: "center",
            outline: "none",
            "&:focus-within": getThemeForKey("radioButton.styleHoverCircle"),
            "&:hover": getThemeForKey("radioButton.styleHoverCircle")
        },
        imageDisabled: {
            display: "flex",
            alignItems: "center",
            outline: "none"
        }
    };
});
